import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavViewComponent } from '@app/features/nav-view/pages/nav-view.component';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';

@NgModule({
    declarations: [
        NavViewComponent
    ],
    imports: [
        CommonModule,
        CoreModule,
        SharedModule
    ],
    providers: []
})
export class NavViewModule {
}
